import { Button, useDisclosure } from "@heroui/react";
import SelectInterviewDateModal from "../SelectInterviewDateModal";

const SelectInterviewDateAction = () => {
  const { isOpen, onOpenChange, onClose } = useDisclosure();

  return (
    <>
      <SelectInterviewDateModal isOpen={isOpen} onOpenChange={onOpenChange} onClose={onClose} />
      <Button variant="bordered" onPress={onOpenChange}>
        Select Interview Date
      </Button>
    </>
  );
};

export default SelectInterviewDateAction;
